import React from "react";

export default function ContentContainer({ children }) {
  return (
    <div className="pt-14 px-14 h-full w-full">
      <div className="h-full">{children}</div>
    </div>
  );
}
